
import '../App.css';
import Header from '../components/Header';
import FolderGallery from '../components/FolderGallery';
import Footer from '../components/Footer';
function App() {
  return (
    <div className="App">

    <Header/> 
    <FolderGallery/>
    
    <Footer/>
    </div>
  );
}

export default App;
